// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3ucb2","label":"CategoryService_label__UpT5D","location":"CategoryService_location__3g081"};